// import React from 'react';

// import Types from '../../common/modules/types';
import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnName = {
  path: 'name',
  sort: 'name',
  width: '100%',
};

export const columnInternal = {
  path: 'internal',
  align: 'right',
  render: record => (
    record.internal ? 'Yes' : '-'
  ),
};

export const columnKind = {
  path: 'kind',
  // width: '100%',
  render: record => (
    !record.kind
    ? '-'
    : `${record.kind[0]}${record.kind.slice(1).toLowerCase()}`
  ),
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

export const ADMIN = [
  columnName,
  columnCreatedAt,
  columnUpdatedAt,
];

export const COMPONENTS = [
  { ...columnName, link: '/website/components/:_id' },
  columnCreatedAt,
  columnUpdatedAt,
];

export const BLOCKS_ADMIN = [
  { ...columnName, link: '/website/blocks/:_id' },
  columnStore,
  columnCreatedAt,
  columnUpdatedAt,
];

export const BLOCKS_SELLER = [
  { ...columnName, link: '/website/blocks/:_id' },
  columnCreatedAt,
  columnUpdatedAt,
];

export const LIBRARY = [
  { ...columnName, link: '/website/library/:_id' },
  columnInternal,
  columnKind,
  columnCreatedAt,
  columnUpdatedAt,
];
